<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? 'switch mb-4 ' + config!.cssClass: 'form-group switch'"
>
  <input
    type="checkbox"
    class="form-check-input"
    [checked]="config ? formGroup?.value[config.name] : false"
    [id]="config?.name"
    [formControlName]="config?.name ?? null"
    [attr.data-testid]="config?.name"
    (click)="changeValue(config?.name); config?.clickHandler?.($event)"
    (change)="onChange($event)"
  />
  <label
    class="form-check-label"
    [for]="config?.name"
  >
    <div class="switch-slider me-2"></div>
    <span class="my-auto">{{ config?.label }}</span>
    @if (config?.toggleWarningExpression?.(this, formModel)) {
      <span class="my-auto ms-2 switch-warning">
        <i class="fas fa-exclamation-triangle"></i>
        {{config!.warningText}}
      </span>
    }
  </label>
  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
